import type { StylesConfig } from "react-select";

import { isThisYear, isToday, isTomorrow, isYesterday } from "date-fns";
import { isEmpty } from "lodash";

import { type RecapTemplate, TEMPLATE_OPTIONS, type TemplateOption } from "~/meetingRecorder/utils";
import { outlinedStyles } from "~/ui/selectors/SelectorUtils";

export function getDateStringForSendNoteModal(date: Date) {
	if (isToday(date)) {
		return "today";
	} else if (isTomorrow(date)) {
		return "tomorrow";
	} else if (isYesterday(date)) {
		return "yesterday";
	} else {
		return `on ${date.toLocaleDateString("en", {
			month: "short",
			day: "numeric",
			year: isThisYear(date) ? undefined : "numeric",
			weekday: "short",
		})}`;
	}
}

export function getRecapTemplateOptions(templatedRecaps: unknown): TemplateOption[] {
	return [
		TEMPLATE_OPTIONS[0], // General Meeting Option
		...TEMPLATE_OPTIONS.filter(option => !isEmpty((templatedRecaps as Record<string, RecapTemplate>)[option.value])),
	];
}

export const recapSelectorStyles: StylesConfig = {
	...outlinedStyles,
	control: (base, state) => ({
		...(outlinedStyles.control?.(base, state) ?? base),
		backgroundColor: "var(--secondLayerColor)",
		opacity: state.isDisabled ? 0.5 : 1,
		"> :last-child": {
			backgroundColor: `var(--${state.isFocused ? "veryMutedRoyal" : "secondLayerColor"})`,
			borderRadius: "6px",
		},
	}),
	singleValue: (base, state) => ({
		...base,
		color: `var(--${state.isDisabled ? "placeholderTextColor" : "primaryTextColor"})`,
	}),
};
